module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('m-panel', {
    attrs: {
      "title": "理赔流程"
    }
  }, [_c('span', {
    slot: "label"
  }, [_vm._v("(理赔材料详见"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.AppConfig.processNotice
    },
    on: {
      "click": function () {
        this$1.$emit('on-recordScroll')
      }
    }
  }, [_vm._v("《理赔须知》")]), _vm._v(")")]), _vm._v(" "), _c('ul', {
    staticClass: "process"
  }, [_c('li', [_c('p', {
    staticClass: "title"
  }, [_vm._v("申请理赔")]), _vm._v(" "), _c('p', {
    staticClass: "content",
    staticStyle: {
      "background-image": "url('static/images/process_line_1.png')"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.lipeiliucheng)
    }
  })]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "title",
    staticStyle: {
      "background-image": "url('static/images/process_2.png')"
    }
  }, [_vm._v("提交材料")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("按照保险公司的要求准备理赔资料并提交")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "title",
    staticStyle: {
      "background-image": "url('static/images/process_3.png')"
    }
  }, [_vm._v("理赔审核")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("保险公司根据理赔材料进行理赔审核")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "title",
    staticStyle: {
      "background-image": "url('static/images/process_4.png')"
    }
  }, [_vm._v("获得赔款")]), _vm._v(" "), _c('p', {
    staticClass: "content",
    staticStyle: {
      "background-image": "url('static/images/process_line_3.png')"
    }
  }, [_vm._v("保险公司支付理赔")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97925a4c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Process.vue
// module id = 663
// module chunks = 1